import { useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";

export default function ProviderProfile() {
  const { user } = useAuth();
  const [form, setForm] = useState({
    business_name: user?.organization || user?.name || "",
    service_type: "transport",
    service_areas: "USA, Canada",
    cold_chain_capabilities: "LN2 Dry Shipper (-196°C), GPS Tracked, Tilt Sensor",
    accreditations: "IATA PCR",
    contact_email: user?.email || "",
    contact_phone: "",
  });

  useEffect(() => {
    if (!user) return;
    api.get("/providers", { params: {} }).then(r => {
      const mine = r.data.providers.find(p => p.user_id === user.user_id);
      if (mine) setForm({
        ...mine,
        service_areas: (mine.service_areas || []).join(", "),
        cold_chain_capabilities: (mine.cold_chain_capabilities || []).join(", "),
        accreditations: (mine.accreditations || []).join(", "),
      });
    });
  }, [user]);

  const submit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        ...form,
        service_areas: form.service_areas.split(",").map(s => s.trim()).filter(Boolean),
        cold_chain_capabilities: form.cold_chain_capabilities.split(",").map(s => s.trim()).filter(Boolean),
        accreditations: form.accreditations.split(",").map(s => s.trim()).filter(Boolean),
      };
      await api.post("/providers", payload);
      toast.success("Profile saved");
    } catch (e) { toast.error(formatApiError(e)); }
  };
  const on = (k) => (e) => setForm({ ...form, [k]: e?.target ? e.target.value : e });

  return (
    <div className="max-w-3xl mx-auto px-6 py-10">
      <h1 className="heading text-3xl font-extrabold tracking-tight">Service Provider Profile</h1>
      <form onSubmit={submit} className="surface-card p-6 mt-6 space-y-4">
        <div><Label>Business name</Label><Input data-testid="prov-name" required value={form.business_name} onChange={on("business_name")} /></div>
        <div>
          <Label>Service type</Label>
          <Select value={form.service_type} onValueChange={on("service_type")}>
            <SelectTrigger><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="transport">Transport / Cold-chain</SelectItem>
              <SelectItem value="vet">Veterinary</SelectItem>
            </SelectContent>
          </Select>
        </div>
        <div><Label>Service areas (comma separated)</Label><Input value={form.service_areas} onChange={on("service_areas")} /></div>
        <div><Label>Cold-chain capabilities</Label><Input value={form.cold_chain_capabilities} onChange={on("cold_chain_capabilities")} /></div>
        <div><Label>Accreditations</Label><Input value={form.accreditations} onChange={on("accreditations")} /></div>
        <div><Label>Contact email</Label><Input type="email" required value={form.contact_email} onChange={on("contact_email")} /></div>
        <div><Label>Contact phone</Label><Input value={form.contact_phone} onChange={on("contact_phone")} /></div>
        <Button data-testid="prov-save-btn" type="submit" className="btn-forest">Save profile</Button>
      </form>
    </div>
  );
}
